module.exports = __webpack_public_path__ + "img/help-dark.632efc38.svg";